// extracted by mini-css-extract-plugin
module.exports = {"root":"TableBody-root-1139ad78db6ecaf366a1f86c363b06a7"};